import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  type ReactNode,
} from 'react';
import {
  applySidebarLayoutCssVars,
  clearSidebarLayoutCssVars,
  getSidebarLayoutMetrics,
  type SidebarLayoutMetrics,
} from './sidebarLayoutMetrics';

const SidebarLayoutContext = createContext<SidebarLayoutMetrics | null>(null);

interface SidebarLayoutProviderProps {
  asideWidth: number;
  isMobile: boolean;
  children: ReactNode;
}

export function SidebarLayoutProvider({
  asideWidth,
  isMobile,
  children,
}: SidebarLayoutProviderProps) {
  const metrics = useMemo(
    () => getSidebarLayoutMetrics(asideWidth, isMobile),
    [asideWidth, isMobile],
  );

  useEffect(() => {
    applySidebarLayoutCssVars(metrics);

    return clearSidebarLayoutCssVars;
  }, [metrics]);

  return (
    <SidebarLayoutContext.Provider value={metrics}>
      {children}
    </SidebarLayoutContext.Provider>
  );
}

export function useSidebarLayoutMetrics(): SidebarLayoutMetrics | null {
  return useContext(SidebarLayoutContext);
}
